import cookies from 'js-cookie'

export const hasViewerToken = () => {
  const viewerToken = cookies.get('viewer_token')
  const connectViewerToken = cookies.get('connect_viewer_token')

  return !!viewerToken || !!connectViewerToken
}

export const shouldFetchUserProfile = (called) => {
  if (called) return false

  if (!hasViewerToken()) return false

  return true
}

export const hasQueryCompleted = (called, queryLoading) =>
  called && !queryLoading

export const isLoading = (called, queryLoading) => {
  if (!hasViewerToken()) return false

  if (hasQueryCompleted(called, queryLoading)) return false

  return true
}

export const getUserProfileFromData = (data) => {
  if (!data?.accountsViewer?.isLoggedIn || !data?.accountsViewer?.userProfile) {
    return {
      isLoggedIn: false
    }
  }

  return {
    isLoggedIn: true,
    ...data.accountsViewer.userProfile
  }
}
